import React, { useState, useEffect, useRef } from "react";
import { IconButton, InputAdornment, TextField } from "@material-ui/core";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ContentEditable from "react-contenteditable";
import { useTranslation } from "react-i18next";
import { getCaretPosition } from "../../../helpers/helper";
import { VariableModal } from "../VariableModal/VariableModal";
export function handleInputStyle (value) {
  return value.replace(
    /(##\w*(\[+\w+\]+)*##)/g,
    '<span class="input-variable">$1</span>'
  );
}

// email validate control
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function TextInput ({
  action,
  inputName,
  variables,
  multiline,
  onBlur,
  include,
  disabled,
  setOpenVariable,
  isRequired,
  setServiceDeskURI,
  setRequestID,
  extractPath = "",
  defaultValue = undefined,
  isCredentialPickerValue,
  inputMode = "text",
  isPassword,

}) {
  const [inputValue, setInputValue] = useState(defaultValue);
  const [open, setOpen] = useState(false);
  const [dropdownValue, setDropdownValue] = useState({});
  const [indexValue, setIndexValue] = useState(0);
  const cursorIndex = useRef(0);
  const [validate, setValidate] = useState(false);
  const [showPassword, setShowPassword] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (inputName) {

      if (!disabled) {
        if (!action.fields[inputName]) {
          if (defaultValue !== undefined) {
            action.fields[inputName] = { isRequired, value: defaultValue, htmlValue: defaultValue };
          }
          else {
            action.fields[inputName] = { isRequired, value: '' };
          }

          if (setServiceDeskURI) {
            setServiceDeskURI("");
          }
          if (setRequestID) {
            setRequestID("");
          }
        }
        if (action.fields[inputName]?.htmlValue) {
          setInputValue(action.fields[inputName].htmlValue);
          if (setServiceDeskURI) {
            setServiceDeskURI(action.fields[inputName].value);
          }
          if (setRequestID) {
            setRequestID(action.fields[inputName].value);
          }
        } else {
          setInputValue("");
          if (setServiceDeskURI) {
            setServiceDeskURI("");
          }
          if (setRequestID) {
            setRequestID("");
          }
        }
      } else { setInputValue(''); }
    } else {
      if (!action) {
        action = { isRequired };
      }
      if (action.htmlValue) {
        setInputValue(action.htmlValue);
      } else {
        setInputValue("");
      }
    }
  }, [action, inputName, disabled]);
  const tagsToReplace = { '&': '&amp;', '<': '&lt;', '>': '&gt;' };
  function replaceTag (tag) { return tagsToReplace[tag] || tag; }
  function safeTagsReplace (str) { return str.replace(/[&<>]/g, replaceTag); }
  const handleChangeState = (event) => {
    // console.log(ref)
    let value = isPassword ? event : event.currentTarget.innerText;
    let result = handleInputStyle(safeTagsReplace(value)); // use safeTagsReplace because of xml tags
    let text = value.replace(/(?:\r\n|\r|\n)/g, "").replace(/\s+/g, " ");

    if (inputName) {
      action.fields[inputName].value = text;
      action.fields[inputName].htmlValue = result;
      // if extract path true
      if (extractPath.length > 0) {
        let file = action.fields[inputName].value.replace(/^.*[\\\/]/, "");
        let fileExtension = file.substring(file.lastIndexOf(".") + 1, file.length);
        let fileName = file.substring(0, file.indexOf("."));
        const key = extractPath + "Name";
        const keyI = extractPath + "Extension";
        if (fileName?.length > 0) {
          action.fields[key] = { value: fileName };
          action.fields[keyI] = { value: fileExtension };
        } else {
          action.fields[key] = { value: fileExtension };
          action.fields[keyI] = { value: fileName };
        }
      }
    } else {
      action.value = text;
      action.htmlValue = result;
    }
    if (setServiceDeskURI) {
      setServiceDeskURI(text);
    }
    if (setRequestID) {
      setRequestID(text);
    }
    if (inputMode === "email") {
      if (emailRegex.test(result)) {
        setValidate(true);
      } else {
        setValidate(false);
      }
    }
    setInputValue(result);
  };

  const handleCursorChange = (event) => {
    cursorIndex.current = getCaretPosition(event.target);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleAddClick = () => {
    if (!cursorIndex.current) {
      cursorIndex.current = inputValue.length;
    }
    if (dropdownValue.name) {
      let firstText = "";
      let lastText = "";
      if (inputName) {
        if (action.fields[inputName]?.value) {
          firstText = action.fields[inputName]?.value.substring(
            0,
            cursorIndex?.current
          );
          lastText = action.fields[inputName]?.value.substring(
            cursorIndex?.current,
            inputValue?.length
          );
        }
      } else {
        if (action.value) {
          firstText = action.value?.substring(0, cursorIndex?.current);
          lastText = action.value?.substring(
            cursorIndex?.current,
            inputValue?.length
          );
        }
      }
      if (dropdownValue.type === "array") {
        firstText += "##" + dropdownValue.name + "[" + indexValue + "]##";
      } else {
        firstText += "##" + dropdownValue.name + "##";
      }
      let newTextValue = firstText + lastText;
      if (inputName) {
        //The action time value is automatically assigned.
        action.fields[inputName].value = newTextValue;
        action.fields[inputName].htmlValue = handleInputStyle(safeTagsReplace(newTextValue)); // style
      } else {
        //The action time value is automatically assigned.
        action.value = newTextValue;
        action.htmlValue = handleInputStyle(safeTagsReplace(newTextValue)); // style
      }
      setInputValue(handleInputStyle(safeTagsReplace(newTextValue)));
    }
    setOpen(false);
  };
  return (
    <div>
      {(((!inputValue && isRequired) && !isCredentialPickerValue) || !validate) && inputMode === "email" && <small>* Enter a valid email address.</small>}
      {((!inputValue && isRequired) && !isCredentialPickerValue) && inputMode === "text" && <small style={{ color: '#D75E5E' }}>{t('FLOW-MESSAGES.LIBRARY.GENERAL.REQUIRED')}</small>}
      <div style={{ display: "flex", alignItems: "flex-start" }}>
        {isPassword ?
            <TextField
              className="editable"
              variant="outlined"
              type={showPassword ? 'text' : 'password'}
              disabled={disabled}
              onBlur={onBlur}
              onChange={(e) => handleChangeState(e.target.value)}
              InputProps={{
                endAdornment:
                  <InputAdornment position="end">
                    <IconButton size="small" onClick={() => setShowPassword((prev) => !prev)}>
                      {showPassword
                        ?
                        <Visibility style={{ fontSize: 14, color: "#8F94A6" }} />
                        :
                        <VisibilityOff style={{ fontSize: 14, color: "#8F94A6" }} />}
                    </IconButton>
                  </InputAdornment>
                , style: { fontWeight: 700, color: "#8F94A6" }
              }} />:
            <ContentEditable
              className="editable"
              onClick={handleCursorChange}
              onKeyUp={handleCursorChange}
              html={inputValue} // innerHTML of the editable div
              disabled={disabled} // use true to disable edition
              onChange={handleChangeState} // handle innerHTML change
              style={{ minHeight: multiline && 100 }}
              onBlur={onBlur}
            />}
        <IconButton style={{ padding: 0, marginTop: '2px' }} onClick={handleClickOpen} disabled={disabled}>
          <AddCircleOutlineIcon style={{ paddingLeft: 5, paddingTop: 5, color: "#8C90A2" }} />
        </IconButton>
        {open && (
          <VariableModal
            setOpen={setOpen}
            variables={variables}
            dropdownValue={dropdownValue}
            setDropdownValue={setDropdownValue}
            setOpenVariable={setOpenVariable}
            indexValue={indexValue}
            setIndexValue={setIndexValue}
            handleAddClick={handleAddClick}
            include={include}
          />
        )}
      </div>
    </div>
  );
}